import tw, { styled } from 'twin.macro';

const Form = styled.form`
  ${tw`mb-4`}

  ${props => props.tall && tw`h-full`}
`;

export default Form;
